import './RolesSection.css';
import React, { useState, useEffect, useCallback } from 'react';
import { loadRoles, saveRole, removeRole } from '../../logic/rolesLogic';
import { ActIcon } from '../../components/AdminIcons';

const MODULES = ['results', 'candidates', 'questions', 'testconfig', 'emailconfig', 'admins'];
const MODULE_LABELS = {
  results: 'Results', candidates: 'Candidates', questions: 'Questions',
  testconfig: 'Test Config', emailconfig: 'Email Settings', admins: 'Admins',
};
const DEFAULT_PERMISSIONS = MODULES.reduce((acc, m) => {
  acc[m] = { view: false, edit: false, delete: false };
  return acc;
}, {});
const PERM_META = {
  results:     { desc: 'Test results & answer analytics',     modIcon: 'M3 3v18h18M7 16l4-4 4 4 4-6', actions: { view: { label: 'View Results',       icon: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z' }, edit: { label: 'Export Results',      icon: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12' }, delete: { label: 'Delete Results',     icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
  candidates:  { desc: 'Candidate accounts & test assignments', modIcon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8', actions: { view: { label: 'View Candidates',    icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8' }, edit: { label: 'Add / Edit Candidate', icon: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM19 8v6M22 11h-6' }, delete: { label: 'Delete Candidate',   icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
  questions:   { desc: 'Question bank management',             modIcon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8', actions: { view: { label: 'View Questions',     icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8' }, edit: { label: 'Add / Edit Question',  icon: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' }, delete: { label: 'Delete Question',    icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
  testconfig:  { desc: 'Test parameters & configurations',     modIcon: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z', actions: { view: { label: 'View Test Config',  icon: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z' }, edit: { label: 'Edit Test Config',  icon: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' }, delete: { label: 'Delete Test Config', icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
  emailconfig: { desc: 'SMTP & email template settings',       modIcon: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6', actions: { view: { label: 'View Email Setup',  icon: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6' }, edit: { label: 'Edit Email Setup',  icon: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' }, delete: { label: 'Reset Email Setup', icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
  admins:      { desc: 'Admin user management',                modIcon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75', actions: { view: { label: 'View Admins',        icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8' }, edit: { label: 'Add / Edit Admin',   icon: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM19 8v6M22 11h-6' }, delete: { label: 'Remove Admin',       icon: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6' } } },
};
const ROLE_PRESETS = {
  admin:   { label: 'Admin',   sub: 'Full access',   icon: '⚡', fn: () => MODULES.reduce((a,m)=>({...a,[m]:{view:true,edit:true,delete:true}}),{}) },
  manager: { label: 'Manager', sub: 'Standard ops',  icon: '📋', fn: () => MODULES.reduce((a,m)=>({...a,[m]:{view:true,edit:true,delete:false}}),{}) },
  viewer:  { label: 'Viewer',  sub: 'Read only',     icon: '👁',  fn: () => MODULES.reduce((a,m)=>({...a,[m]:{view:true,edit:false,delete:false}}),{}) },
};

export default function RolesSection({ notify }) {
  const [roles, setRoles] = useState([]);
  const [roleForm, setRoleForm] = useState({ name: '', permissions: { ...DEFAULT_PERMISSIONS } });
  const [roleEditId, setRoleEditId] = useState(null);
  const [roleEditing, setRoleEditing] = useState(false);
  const [permSearch, setPermSearch] = useState('');
  const [collapsedMods, setCollapsedMods] = useState(new Set());
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});
  const isBusy = key => !!busy[key];
  const withBusy = async (key, fn) => {
    setBusy(b => ({ ...b, [key]: true }));
    try { await fn(); } finally { setBusy(b => ({ ...b, [key]: false })); }
  };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const roles = await loadRoles();
      setRoles(roles);
    } catch (e) { notify(e.response?.data?.message || 'Failed to load roles', true); }
    finally { setLoading(false); }
  }, [notify]);

  useEffect(() => { load(); }, [load]);

  const handleSaveRole = async e => {
    e.preventDefault();
    await withBusy('save-role', async () => {
      try {
        const action = await saveRole(roleForm, roleEditId);
        notify(action === 'updated' ? 'Role updated' : 'Role created');
        if (action === 'updated') setRoleEditId(null);
        setRoleForm({ name: '', permissions: { ...DEFAULT_PERMISSIONS } });
        setRoleEditing(false);
        load();
      } catch (err) { notify(err.response?.data?.message || 'Failed', true); }
    });
  };

  const editRole = (r) => {
    setRoleEditId(r.id);
    const perms = { ...DEFAULT_PERMISSIONS };
    for (const m of MODULES) {
      perms[m] = {
        view:   !!(r.permissions?.[m]?.view),
        edit:   !!(r.permissions?.[m]?.edit),
        delete: !!(r.permissions?.[m]?.delete),
      };
    }
    setRoleForm({ name: r.name, permissions: perms });
    setPermSearch('');
    setCollapsedMods(new Set());
    setRoleEditing(true);
  };

  const handleDeleteRole = async (id, name) => {
    if (!window.confirm(`Delete role "${name}"?`)) return;
    await withBusy(`delete-role-${id}`, async () => {
      try {
        await removeRole(id);
        notify(`Role "${name}" deleted`); load();
      } catch (err) { notify(err.response?.data?.message || 'Failed', true); }
    });
  };

  const togglePerm = (module, action) => {
    setRoleForm(f => ({
      ...f,
      permissions: {
        ...f.permissions,
        [module]: { ...f.permissions[module], [action]: !f.permissions[module][action] },
      },
    }));
  };

  return (
    <div className="fade-up">
      {/* ── ROLES LIST ── */}
      {!roleEditing && (
        <div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'1.5rem'}}>
            <div>
              <h3 style={{margin:0}}>Manage Roles</h3>
              <p style={{fontSize:'0.82rem',color:'var(--muted)',marginTop:'0.25rem'}}>Create and manage access-control roles for your admin team.</p>
            </div>
            <button className="btn btn-primary" onClick={()=>{setRoleEditId(null);setRoleForm({name:'',permissions:{...DEFAULT_PERMISSIONS}});setPermSearch('');setCollapsedMods(new Set());setRoleEditing(true);}}>
              + New Role
            </button>
          </div>
          {loading
            ? <div className="admin-loading"><div className="spinner"/></div>
            : roles.length===0
            ? <div className="empty-state"><span>🔐</span><p>No roles yet. Create one to get started.</p></div>
            : <div className="results-table-wrap"><table className="results-table">
                <thead><tr><th>Role Name</th><th>Admins</th><th>Permissions</th><th>Actions</th></tr></thead>
                <tbody>{roles.map(r=>(
                  <tr key={r.id}>
                    <td><strong>{r.name}</strong></td>
                    <td><span className="badge badge-purple">{r.admin_count||0} admin{r.admin_count!==1?'s':''}</span></td>
                    <td>
                      <div style={{display:'flex',flexWrap:'wrap',gap:'0.25rem'}}>
                        {MODULES.map(mod=>{
                          const p=r.permissions?.[mod];
                          if(!p?.view&&!p?.edit&&!p?.delete) return null;
                          const parts=[];
                          if(p.view) parts.push('view');
                          if(p.edit) parts.push('edit');
                          if(p.delete) parts.push('del');
                          return <span key={mod} className="badge badge-purple" style={{fontSize:'0.65rem'}}>{MODULE_LABELS[mod]}: {parts.join('+')}</span>;
                        })}
                        {MODULES.every(m=>!r.permissions?.[m]?.view&&!r.permissions?.[m]?.edit&&!r.permissions?.[m]?.delete)&&<span style={{fontSize:'0.78rem',color:'var(--muted)'}}>No permissions</span>}
                      </div>
                    </td>
                    <td><div className="action-btns">
                      <button className="act-btn info" title="Edit" onClick={()=>editRole(r)}><ActIcon type="edit"/></button>
                      <button className="act-btn danger" title="Delete" disabled={isBusy(`delete-role-${r.id}`)} onClick={()=>handleDeleteRole(r.id,r.name)}>
                        {isBusy(`delete-role-${r.id}`)?<span className="act-spinner"/>:<ActIcon type="trash"/>}
                      </button>
                    </div></td>
                  </tr>
                ))}</tbody>
              </table></div>
          }
        </div>
      )}

      {/* ── ROLE EDITOR ── */}
      {roleEditing && (
        <form onSubmit={handleSaveRole} className="rp-editor">
          {/* ── LEFT SIDEBAR ── */}
          <div className="rp-left">
            <div className="rp-avatar-wrap">
              <div className="rp-avatar">
                {roleForm.name
                  ? roleForm.name.trim().split(/\s+/).slice(0,2).map(w=>w[0]).join('').toUpperCase() || '?'
                  : '?'}
              </div>
            </div>

            <div className="input-group" style={{marginBottom:'1.1rem'}}>
              <label style={{fontSize:'0.7rem',fontWeight:700,letterSpacing:'0.07em',color:'var(--muted)',textTransform:'uppercase'}}>Role Name *</label>
              <input className="input-field rp-name-input" placeholder="e.g. Fleet Manager"
                value={roleForm.name}
                onChange={e=>setRoleForm(f=>({...f,name:e.target.value}))}
                required
              />
            </div>

            {roleEditId && roles.find(r=>r.id===roleEditId) && (()=>{
              const r = roles.find(x=>x.id===roleEditId);
              return (
                <div className="rp-meta">
                  <div className="rp-meta-row"><span>Role ID</span><span className="rp-meta-val">#{r.id}</span></div>
                  <div className="rp-meta-row"><span>Created</span><span className="rp-meta-val">{new Date(r.created_at||r.createdAt||Date.now()).toLocaleDateString('en-CA')}</span></div>
                  <div className="rp-meta-row"><span>Last Updated</span><span className="rp-meta-val">{new Date(r.updated_at||r.updatedAt||Date.now()).toLocaleDateString('en-CA')}</span></div>
                  <div className="rp-meta-row"><span>Admins</span><span className="rp-meta-val">{r.admin_count||0}</span></div>
                </div>
              );
            })()}

            <div className="rp-presets-section">
              <p className="rp-presets-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'5px'}}><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                Quick Presets
              </p>
              <div className="rp-presets-grid">
                {Object.entries(ROLE_PRESETS).map(([key,preset])=>(
                  <button key={key} type="button" className="rp-preset-btn"
                    onClick={()=>setRoleForm(f=>({...f,permissions:preset.fn()}))}>
                    <div className="rp-preset-icon-wrap">{preset.icon}</div>
                    <div className="rp-preset-name">{preset.label}</div>
                    <div className="rp-preset-sub">{preset.sub}</div>
                  </button>
                ))}
              </div>
            </div>

            <div className="rp-left-actions">
              <button type="submit" className="btn btn-primary rp-save-btn" disabled={isBusy('save-role')}>
                {isBusy('save-role')
                  ? <><span className="btn-spinner"/>{roleEditId?'Updating…':'Creating…'}</>
                  : <><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{marginRight:'7px'}}><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
                    {roleEditId ? 'Save Changes' : 'Create Role'}</>
                }
              </button>
              <button type="button" className="btn btn-outline rp-cancel-btn"
                onClick={()=>{setRoleEditing(false);setRoleEditId(null);setRoleForm({name:'',permissions:{...DEFAULT_PERMISSIONS}});}}>
                Cancel
              </button>
            </div>
          </div>

          {/* ── RIGHT PANEL ── */}
          <div className="rp-right">
            <div className="rp-right-toolbar">
              <div className="rp-search-wrap">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" className="rp-search-icon"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <input className="rp-search-input" placeholder="Search permissions..."
                  value={permSearch} onChange={e=>setPermSearch(e.target.value)}/>
              </div>
              <div style={{display:'flex',gap:'0.5rem',alignItems:'center',flexShrink:0}}>
                <button type="button" className="btn btn-primary btn-sm"
                  onClick={()=>setRoleForm(f=>({...f,permissions:MODULES.reduce((a,m)=>({...a,[m]:{view:true,edit:true,delete:true}}),{})}))}>
                  Select All
                </button>
                <button type="button" className="btn btn-outline btn-sm"
                  onClick={()=>setRoleForm(f=>({...f,permissions:MODULES.reduce((a,m)=>({...a,[m]:{view:false,edit:false,delete:false}}),{})}))}>
                  Clear All
                </button>
                <span className="rp-enabled-badge">
                  {MODULES.reduce((s,m)=>s+['view','edit','delete'].filter(a=>roleForm.permissions[m]?.[a]).length,0)} of {MODULES.length*3} enabled
                </span>
              </div>
            </div>

            <div className="rp-modules-list">
              {MODULES.filter(mod=>{
                if(!permSearch.trim()) return true;
                const q=permSearch.toLowerCase();
                return MODULE_LABELS[mod].toLowerCase().includes(q)
                  || Object.values(PERM_META[mod].actions).some(a=>a.label.toLowerCase().includes(q));
              }).map(mod=>{
                const meta=PERM_META[mod];
                const isCollapsed=collapsedMods.has(mod);
                const enabledCount=['view','edit','delete'].filter(a=>roleForm.permissions[mod]?.[a]).length;
                const totalCount=Object.keys(meta.actions).length;
                const visibleActions=Object.entries(meta.actions).filter(([,a])=>
                  !permSearch.trim()||a.label.toLowerCase().includes(permSearch.toLowerCase())
                );
                return (
                  <div key={mod} className="rp-mod-card">
                    <div className="rp-mod-header"
                      onClick={()=>setCollapsedMods(s=>{const n=new Set(s);n.has(mod)?n.delete(mod):n.add(mod);return n;})}>
                      <div className="rp-mod-icon-wrap">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <path d={meta.modIcon}/>
                        </svg>
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div className="rp-mod-name">{MODULE_LABELS[mod]}</div>
                        <div className="rp-mod-desc">{meta.desc}</div>
                      </div>
                      <span className={`rp-mod-count ${enabledCount===totalCount?'rp-count-full':enabledCount>0?'rp-count-partial':''}`}>
                        {enabledCount}/{totalCount}
                      </span>
                      <svg className={`rp-chevron${isCollapsed?' rp-chevron-collapsed':''}`} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="18 15 12 9 6 15"/></svg>
                    </div>
                    {!isCollapsed && (
                      <div className="rp-perms-grid">
                        {visibleActions.map(([action,ameta])=>(
                          <label key={action} className={`rp-perm-item${roleForm.permissions[mod]?.[action]?' rp-perm-on':''}`}
                            onClick={e=>e.preventDefault()}
                            onMouseDown={e=>{e.preventDefault();togglePerm(mod,action);}}>
                            <div style={{display:'flex',alignItems:'center',gap:'0.6rem',flex:1,minWidth:0}}>
                              <div className="rp-perm-icon">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <path d={ameta.icon}/>
                                </svg>
                              </div>
                              <span className="rp-perm-label">{ameta.label}</span>
                            </div>
                            <div className="rp-toggle">
                              <input type="checkbox" readOnly checked={!!roleForm.permissions[mod]?.[action]}/>
                              <span className="rp-toggle-slider"/>
                            </div>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </form>
      )}
    </div>
  );
}
